export default __webpack_public_path__ + "static/media/audio-spectrum.3fcf5c87.svg";